import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './StagePublic.css';

/**
 * « VÉRIFIER CE DOCUMENT » — la page du QR code des convocations (lot PO.4b-2, D28), PUBLIQUE (sans connexion).
 *
 * Scannée par l'employeur d'un apprenti, un maître de stage, une scolarité : elle dit si le document est AUTHENTIQUE
 * (jeton signé par le serveur), par quel département et quand il a été émis, pour un oral de quelle date — et si
 * l'horaire a CHANGÉ depuis (Bertrand, 2026-10-16 : une convocation dépassée ne doit pas servir de preuve).
 * ⚠️ AUCUNE DONNÉE PERSONNELLE : ni nom, ni entreprise, ni titre du planning (règle RGPD stricte). Le texte le dit.
 */
const dateFr = (iso) => (iso ? new Date(iso + 'T12:00:00').toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : '');

export default function VerifierDocument() {
    const { jeton } = useParams();
    const [r, setR] = useState(null);
    const [erreur, setErreur] = useState(null);

    useEffect(() => {
        // appel SANS le jeton de session (page publique) : axios nu, pas le client authentifié de l'application
        axios.get(`/api/public/verification/${encodeURIComponent(jeton || '')}`)
            .then((x) => setR(x.data))
            .catch((e) => setErreur(e.response?.status === 429 ? 'Trop de vérifications depuis cette adresse : réessayez dans quelques minutes.' : 'Le service de vérification ne répond pas. Réessayez plus tard.'));
    }, [jeton]);

    if (!r && !erreur) {
        return <div className="pub-page"><div className="pub-message"><i className="fa-solid fa-circle-notch pub-tourne" /><div>Vérification du document…</div></div></div>;
    }
    const ok = r?.authentique;
    const etat = r?.etat;
    return (
        <div className="pub-page">
            <div className="form-public verif-carte">
                <div className="form-public-header">
                    <h2><i className="fa-solid fa-qrcode" /> Vérification d'un document</h2>
                    <p>{ok ? (r.departement?.etablissement || `Département ${r.departement?.code || ''}`) : 'Document généré par l\'application du département'}</p>
                </div>
                <div className="form-public-body">
                    {erreur && <div className="verif-bandeau ko"><i className="fa-solid fa-plug-circle-xmark" /><div><b>Vérification impossible</b><br />{erreur}</div></div>}
                    {r && !ok && (
                        <div className="verif-bandeau ko"><i className="fa-solid fa-circle-xmark" />
                            <div><b>Document non reconnu</b><br />Ce code ne correspond à aucun document émis par l'application. Le document a pu être modifié, ou le code mal recopié : demandez-en un original au département.</div></div>
                    )}
                    {ok && (<>
                        <div className="verif-bandeau ok"><i className="fa-solid fa-circle-check" />
                            <div><b>Document authentique</b><br />{r.document}, émise par le département <b>{r.departement?.code}</b>{r.departement?.nom ? ` (${r.departement.nom})` : ''} le <b>{dateFr(r.emis_le)}</b>.</div></div>
                        {etat === 'modifie' && <div className="verif-bandeau alerte"><i className="fa-solid fa-triangle-exclamation" />
                            <div><b>L'horaire de cet oral a changé depuis l'émission de ce document.</b><br />Ce document n'est plus à jour : demandez la convocation à jour au département.</div></div>}
                        {etat === 'annule' && <div className="verif-bandeau alerte"><i className="fa-solid fa-triangle-exclamation" />
                            <div><b>Cet oral n'est plus prévu à l'horaire indiqué</b> (passage déplacé, retiré ou planning supprimé).<br />Renseignez-vous auprès du département.</div></div>}
                        <dl className="verif-details">
                            <dt>Oral prévu</dt><dd>{dateFr(r.oral?.date)} à {r.oral?.heure}{etat === 'a_jour' ? <span className="verif-ajour"> · toujours à jour</span> : null}</dd>
                            <dt>Référence</dt><dd><code>{r.reference}</code></dd>
                        </dl>
                    </>)}
                </div>
                <div className="form-public-footer verif-pied">
                    {/* ⚠️ un seul span : dans un conteneur flex, chaque morceau de texte devient une colonne */}
                    <i className="fa-solid fa-user-shield" /><span>Cette page ne montre <b>aucune donnée personnelle</b> : comparez la date et la référence avec le document papier.</span>
                </div>
            </div>
        </div>
    );
}
